import Button from "./Button.tsx";
import Icon from "./Icon.tsx";

interface Props {
  quantity: number;
  disabled?: boolean;
  loading?: boolean;
  max?: number;
  onChange?: (quantity: number) => void;
}

function QuantitySelector(
  { onChange, quantity, disabled, loading, max = 100 }: Props,
) {
  const decrement = () => onChange?.(Math.max(0, quantity - 1));

  const increment = () => onChange?.(Math.min(quantity + 1, max));

  return (
    <div class="flex items-center">
      <Button
        class="w-8 h-8 border border-tw-primary-100 rounded text-tw-primary-100 text-lg transition-colors duration-300 flex justify-center items-center hover:border-tw-base-100 hover:bg-tw-base-100"
        onClick={decrement}
        disabled={disabled}
        loading={loading}
        title="Diminuir quantidade"
        aria-label="Diminuir quantidade"
      >
        <Icon id="Minus" class="text-tw-primary-100" width={12} height={3} />
      </Button>

      <input
        class="text-tw-neutral-500 text-sm text-center"
        type="number"
        name="quantity"
        aria-label="Quantidade selecionada"
        inputMode="numeric"
        pattern="[0-9]*"
        max={max}
        min={1}
        value={quantity}
        disabled={disabled}
        onBlur={(e) => onChange?.(e.currentTarget.valueAsNumber)}
      />

      <Button
        class="w-8 h-8 border border-tw-primary-100 rounded text-tw-primary-100 text-lg transition-colors duration-300 flex justify-center items-center hover:bg-tw-primary-100 group"
        onClick={increment}
        disabled={disabled}
        loading={loading}
        title="Aumentar quantidade"
        aria-label="Aumentar quantidade"
      >
        <Icon
          id="Plus"
          class="text-tw-primary-100 transition-colors duration-300 group-hover:text-white"
          width={12}
          height={12}
        />
      </Button>
    </div>
  );
}

export default QuantitySelector;
